import React from 'react';
import { motion } from 'framer-motion';
const products = [{
  name: 'Mercedes-Maybach S-Class',
  price: 'Từ 14.5 tỷ VNĐ',
  version: 'S 580 4MATIC',
  image: 'https://images.unsplash.com/photo-1616422285623-13ff0162193c?q=80&w=1931&auto=format&fit=crop'
}, {
  name: 'Mercedes-Maybach GLS',
  price: 'Từ 12.8 tỷ VNĐ',
  version: 'GLS 600',
  image: 'https://images.unsplash.com/photo-1606220838315-056192d5e927?q=80&w=1974&auto=format&fit=crop'
}, {
  name: 'Mercedes-Maybach EQS',
  price: 'Từ 13.5 tỷ VNĐ',
  version: '680 SUV',
  image: 'https://images.unsplash.com/photo-1617788138017-80ad40651399?q=80&w=2070&auto=format&fit=crop'
}, {
  name: 'Mercedes-AMG GT',
  price: 'Từ 9.2 tỷ VNĐ',
  version: '63 S 4MATIC+',
  image: 'https://images.unsplash.com/photo-1618843479313-40f8afb4b4d8?q=80&w=2070&auto=format&fit=crop'
}, {
  name: 'Mercedes-Benz E-Class',
  price: 'Từ 2.3 tỷ VNĐ',
  version: 'E 200 Exclusive',
  image: 'https://images.unsplash.com/photo-1609520505218-7421da4c3c7c?q=80&w=2070&auto=format&fit=crop'
}, {
  name: 'Mercedes-Benz GLE',
  price: 'Từ 4.7 tỷ VNĐ',
  version: '450 4MATIC',
  image: 'https://images.unsplash.com/photo-1622199583626-47636e3d2313?q=80&w=2070&auto=format&fit=crop'
}];
export function NewProducts() {
  return <section className="py-24 bg-gray-50" data-id="element-170">
      <div className="max-w-7xl mx-auto px-6" data-id="element-171">
        <div className="text-center mb-16" data-id="element-172">
          <h2 className="text-3xl md:text-4xl font-light text-black mb-4" data-id="element-173">
            SẢN PHẨM MỚI
          </h2>
          <p className="text-gray-500 font-light" data-id="element-174">
            Khám phá những kiệt tác mới nhất
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-12" data-id="element-175">
          {products.map((car, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="group" data-id="element-176">
              <div className="relative aspect-[4/3] overflow-hidden mb-6 bg-gray-200 rounded-2xl" data-id="element-177">
                <img src={car.image} alt={car.name} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" data-id="element-178" />
                <div className="absolute inset-0 bg-black/0 group-hover:bg-black/10 transition-colors duration-500" data-id="element-179" />
              </div>

              <div className="text-center" data-id="element-180">
                <h3 className="text-xl font-medium text-black mb-1" data-id="element-181">
                  {car.name}
                </h3>
                <p className="text-gray-500 font-light text-sm mb-2" data-id="element-182">
                  {car.version}
                </p>
                <p className="text-[#D4AF37] font-light" data-id="element-183">{car.price}</p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}